function loginFormHelperDirective($state) {
  "ngInject";
  return {
    restrict: 'A',
    link: function(scope, el, attrs) {
      let showOn = attrs.showOn
      if (showOn) showOn = showOn.split("|");
      showOn.map((stateName) => {
        if ($state.is(stateName)) {
          el.removeClass('hidden')
        }
      });
    }
  };
}
export default loginFormHelperDirective;



// WEBPACK FOOTER //
// ./js/containers/users/directives/loginFormHelper.js